import * as _ from 'lodash';

export class CopyHelper {
    public static cloneDeep(obj: object) {
        return _.cloneDeep(obj);
    }
}
